<template>
  <div class="icon-container">
    <span class="video-icon" v-if="type === DATA_TYPE.get('video')"></span>
    <div class="text-icon" v-else>{{markText}}</div>
  </div>
</template>

<script>
import VueTypes from 'vue-types'
import { DATA_TYPE } from './utils'
export default {
  name: 'event-detail-download-icon',
  props: {
    /**
     * 文件类型，默认为文档
     * 1 图片
     * 5 文档
     * 3 视频
     * 4 PPT
     * 16 直播地址
     */
    type: VueTypes.number.isRequired
  },
  data () {
    return {
      DATA_TYPE
    }
  },
  computed: {
    markText: function () {
      switch (this.type) {
        case this.DATA_TYPE.get('video'):
          return 'V'
        case this.DATA_TYPE.get('ppt'):
          return 'P'
        case this.DATA_TYPE.get('word'):
          return 'W'
        default: return 'W'
      }
    }

  }
}
</script>

<style lang="scss" scoped>
  .icon-container{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px; height: 40px;
    margin-right: 10px;
    background: #D7B375;
    border-radius: 4px;

    .text-icon{
      line-height: 28px;
      font-size: 20px; font-weight: 900; color: #FFF;
    }

     .video-icon{
       width: 0;height: 0;
       border-width: 8px 0 8px 12px;
       border-color: transparent transparent transparent #FFF;
       border-style: solid;
     }
  }
</style>
